import { render, staticRenderFns } from "./giftfinder.vue?vue&type=template&id=61b480ce&scoped=true"
import script from "./giftfinder.vue?vue&type=script&lang=js"
export * from "./giftfinder.vue?vue&type=script&lang=js"
import style0 from "./giftfinder.vue?vue&type=style&index=0&id=61b480ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b480ce",
  null
  
)

export default component.exports